import React, { useState } from "react";
import FaqImmobilier from "./FaqImmobilier";
import FaqVehicules from "./FaqVehicules";
import FaqEmploi from "./FaqEmploi";
import FaqMode from "./FaqMode";
import FaqMaisonJardin from "./FaqMaisonJardin";
import FaqElectronique from "./FaqElectronique";
import FaqLoisirs from "./FaqLoisirs";
import FaqDivers from "./FaqDivers";
const FaqCategorie = ({ numeroComponent, idCategorie }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <>
      <div className="support_content_recherche">
        <div className="support_faq_section">
          {numeroComponent == 1 && (
            <FaqImmobilier
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 2 && (
            <FaqVehicules
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 3 && (
            <FaqEmploi
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 4 && (
            <FaqMode
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 5 && (
            <FaqMaisonJardin
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 6 && (
            <FaqElectronique
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 7 && (
            <FaqLoisirs
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
          {numeroComponent == 8 && (
            <FaqDivers
              setOpenIndex={setOpenIndex}
              openIndex={openIndex}
              toggleFAQ={toggleFAQ}
              idCategorie={idCategorie}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default FaqCategorie;
